import { defineMessages } from 'react-intl';

export default defineMessages({
  detailString: {
    id: 'detail',
    description: 'detail',
    defaultMessage: 'Detail',
  },
  removeString: {
    id: 'remove',
    description: 'remove',
    defaultMessage: 'Remove',
  },
  duplicateString: {
    id: 'duplicate',
    description: 'duplicate',
    defaultMessage: 'Duplicate',
  },
});
